var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-514ab153.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-d8694455.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M4.288 2.402 8 6.114 14.065.05A56.78 56.78 0 0 1 16 0v1.886L9.886 8 16 14.114V16h-1.886L8 9.886 1.886 16H.003v-.017c-.008-.614 0-1.249.027-1.898L6.114 8 2.467 4.353a9.023 9.023 0 0 1 1.821-1.95Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M14.555.031C15.035.015 15.518.004 16 0L8.472 7.529l-.708-.708 6.791-6.79ZM3.308 3.307l4.22 4.222-.706.707-4.157-4.157c.194-.26.408-.52.643-.772ZM.003 16v-.003L7.53 8.47l.707.708L1.414 16H.004Zm8.469-7.529.707-.707L16 14.586V16L8.472 8.471Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M10 .399V16H6V1.372c.112-.05.226-.097.342-.143C7.272.875 8.544.6 10 .4Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M1.529 6H16v4H.442a30.35 30.35 0 0 1 .424-2.125s.169-.803.663-1.875Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M9.334.498V16H6.667V1.114C7.403.867 8.312.662 9.334.498Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M1.246 6.667H16v2.666H.558c.09-.485.193-.972.308-1.458 0 0 .102-.487.38-1.208Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#9C3900",
      fillRule: "evenodd",
      d: "M22 11.667c0-.737.597-1.334 1.333-1.334H24c.736 0 1.333.597 1.333 1.334v.607H22v-.607Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M20.961 22.258c.776-.571 1.684-.858 2.706-.858s1.93.288 2.705.858c.519-.869 1.266-1.365 1.724-1.122.487.26.462 1.26-.056 2.236-.519.975-1.335 1.555-1.822 1.296-.318-.17-.418-.653-.306-1.24-.622-.554-1.361-.828-2.245-.828-.884 0-1.623.273-2.246.828.113.587.013 1.07-.305 1.24-.488.26-1.303-.321-1.822-1.296-.518-.976-.544-1.977-.056-2.236.458-.243 1.205.253 1.723 1.122Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#CDAD56",
      d: "M22.843 6.887c.042-.03.083-.06.122-.092a.168.168 0 0 1 .006-.022c.083-.247.048-.45-.104-.631a.167.167 0 0 1 .255-.215.926.926 0 0 1 .218.479c.18-.249.254-.498.175-.67a.167.167 0 0 1 .303-.14c.279.606-.443 1.553-1.43 1.898a.167.167 0 0 1-.11-.314 2.21 2.21 0 0 0 .187-.076l.001-.003c.072-.2.055-.354-.046-.484a.167.167 0 0 1 .263-.204c.11.14.162.3.16.474Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#CDAD56",
      d: "M21.869 6.887a.74.74 0 0 1 .16-.474.167.167 0 1 1 .263.204c-.101.13-.118.284-.047.484l.002.003c.06.028.123.053.187.076a.167.167 0 1 1-.11.314c-.987-.345-1.709-1.292-1.43-1.897a.167.167 0 1 1 .303.14c-.08.17-.005.42.175.669a.926.926 0 0 1 .218-.479.167.167 0 1 1 .255.215c-.152.18-.187.384-.104.63a.184.184 0 0 1 .006.023c.039.032.08.062.122.092Z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m25.03 12 .693-1.135a.333.333 0 0 1 .055-.067L26.96 9.67c.083-.08.2-.11.312-.082l1.017.257a.333.333 0 0 1 .122.587l-1.224.945a.333.333 0 0 0-.12.188l-.541 2.296a.333.333 0 0 1-.16.213l-1.033.592H22l-1.034-.592a.333.333 0 0 1-.159-.213l-.54-2.296a.333.333 0 0 0-.121-.188l-1.224-.945a.333.333 0 0 1 .122-.587l1.017-.257a.333.333 0 0 1 .312.082l1.182 1.127c.02.02.04.042.054.067L22.303 12h2.727Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#9C3900",
      fillRule: "evenodd",
      d: "M22.697 7.203a.111.111 0 0 0 .15.078l.077-.031a.158.158 0 0 1 .172.256l-.026.027a.182.182 0 0 1-.131.056h-.007a.198.198 0 0 0-.191.246l.034.136a.306.306 0 0 0 .23.222l.238.053a.5.5 0 0 0 .182.007L24 8.168a.5.5 0 0 1 .212.015l.51.148a.288.288 0 0 1 .182.16l.114.256a.126.126 0 0 1-.128.176.126.126 0 0 0-.137.1l-.006.032a.162.162 0 0 0 .03.129l.138.184a.5.5 0 0 1 .1.32l-.025.656a.479.479 0 0 1-.026.139l-.057.163a.24.24 0 1 1-.44-.187l.246-.488a.21.21 0 1 0-.383-.168l-.231.608a.18.18 0 1 1-.327-.152l.171-.312a.36.36 0 0 0 .042-.215l-.017-.152a.327.327 0 0 0-.65.02l-.045.85a.176.176 0 1 1-.35-.035c.056-.404.154-1.127.138-1.124-.178.04-.282.227-.282.408v.805a.222.222 0 0 1-.422.097l-.016-.032a.268.268 0 0 1 0-.236l.045-.093a.483.483 0 0 0 .048-.21v-.37a.5.5 0 0 0-.083-.275l-.178-.27a.5.5 0 0 1-.08-.316l.044-.546a.5.5 0 0 0-.093-.333l-.098-.137a.336.336 0 0 0-.273-.14H21.6a.184.184 0 0 1-.141-.066l-.005-.006a.178.178 0 0 1 .168-.288l.127.022c.08.014.16-.023.2-.092a.194.194 0 0 1 .168-.096h.471a.11.11 0 0 1 .108.086Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "M28 20.667c.736 0 1.333-1.642 1.333-3.667s-.597-3.667-1.333-3.667-1.334 1.642-1.334 3.667.598 3.667 1.334 3.667Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#D9D9D9",
      fillRule: "evenodd",
      d: "M19.333 20.667c.737 0 1.334-1.642 1.334-3.667s-.597-3.667-1.334-3.667C18.597 13.333 18 14.975 18 17s.597 3.667 1.333 3.667Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#656263",
      fillRule: "evenodd",
      d: "M22 12.222a.89.89 0 0 1 .89-.889h1.555a.89.89 0 0 1 .889.89v.256a.187.187 0 0 1-.188.188.187.187 0 0 0-.181.142l-.2.802a.5.5 0 0 0 .26.568l.528.264a.5.5 0 0 1 .224.67l-.444.887H22l-.443-.886a.5.5 0 0 1 .224-.67l.527-.265a.5.5 0 0 0 .262-.568l-.201-.803a.187.187 0 0 0-.182-.141.187.187 0 0 1-.187-.188v-.257Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M21.334 15.333H26V18s0 2.333-2.333 3.333C21.333 20.331 21.333 18 21.333 18v-2.667Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1FCE6D",
      fillRule: "evenodd",
      d: "M22 15.333h3.333l-1.666 5.334L22 15.333Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagSgs = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagSgs_default = SvgFlagSgs;
export {
  FlagSgs_default as default
};
